import { useMemo } from "react";

const mulberry32 = (a) => () => {
  a |= 0;
  a = (a + 0x6d2b79f5) | 0;
  let t = Math.imul(a ^ (a >>> 15), 1 | a);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

export const ContourField = ({ opacity = 0.07, color = "#14110D", seed = 11 }) => {
  const blobs = useMemo(() => {
    const rnd = mulberry32(seed);
    const out = [];
    const count = 7;
    for (let i = 0; i < count; i++) {
      const cx = rnd() * 1440;
      const cy = rnd() * 900;
      const base = 60 + rnd() * 130;
      const rings = 4 + Math.floor(rnd() * 3);
      for (let r = 0; r < rings; r++) {
        const rad = base + r * (34 + rnd() * 10);
        const pts = [];
        const steps = 10;
        for (let s = 0; s < steps; s++) {
          const ang = (s / steps) * Math.PI * 2;
          const wobble = rad * (0.82 + rnd() * 0.36);
          pts.push([cx + Math.cos(ang) * wobble, cy + Math.sin(ang) * wobble]);
        }
        let d = `M ${pts[0][0].toFixed(1)} ${pts[0][1].toFixed(1)}`;
        for (let s = 1; s <= steps; s++) {
          const p0 = pts[(s - 1) % steps];
          const p1 = pts[s % steps];
          const mx = ((p0[0] + p1[0]) / 2).toFixed(1);
          const my = ((p0[1] + p1[1]) / 2).toFixed(1);
          d += ` Q ${p0[0].toFixed(1)} ${p0[1].toFixed(1)} ${mx} ${my}`;
        }
        d += " Z";
        out.push(d);
      }
    }
    return out;
  }, [seed]);

  return (
    <svg
      className="pointer-events-none absolute inset-0 h-full w-full"
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      {blobs.map((d, i) => (
        <path key={i} d={d} fill="none" stroke={color} strokeWidth="1" opacity={opacity} />
      ))}
    </svg>
  );
};
